import ReactDOM from 'react-dom';
import App from './app/App';
import logClient, { LogLevels } from 'c9-js-log-client';
import './assets/styles/common.css';
import { AppConfigService } from './common/services/AppConfigService';
import { AppContextProvider } from './common/context/AppContextProvider';
import { IAppConfig } from './common/interface/IAppConfig';
import { BrowserRouter as Router } from 'react-router-dom';

const context: any = window || {};

context.OnsaB2B = (function () {
    function boostrapApplication(boostrapElement: HTMLElement) {
        const awsHost = boostrapElement.getAttribute('data-apiawshost')
            ? (boostrapElement.getAttribute('data-apiawshost') as string)
            : '';
        const config: IAppConfig = AppConfigService(awsHost);
        if (boostrapElement.getAttribute('data-basename')) {
            config.baseName = boostrapElement.getAttribute('data-basename') as string;
        }
        const c9log = logClient(config.logger, config.appName, LogLevels.debug);
        c9log
            .debug(`Starting up application ${c9log.appName}, basename ${config.baseName}`, 'bootstrap')
            .catch((err) => {
                console.log('logger service has failed', err);
            });

        function WrapAppWithContext() {
            return (
                <Router basename={config.baseName}>
                    <AppContextProvider config={config} c9log={c9log}>
                        <App config={config} c9log={c9log} />
                    </AppContextProvider>
                </Router>
            );
        }

        ReactDOM.render(<WrapAppWithContext />, boostrapElement);
    }

    return boostrapApplication;
})();

window.addEventListener('load', function () {
    new context.OnsaB2B(document.getElementsByTagName('onsa-b2b').item(0));
});
